'use client'

import React from 'react'

import './_link.scss'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

type Props<T extends React.ElementType> = Overwrite<
  CommonProps<T>,
  {
    as?: T
    children?: React.ReactNode
    href?: string
    appearance?: 'base' | 'unobtrusive' | 'noUnderline'
    onClick?: (event: React.MouseEvent, href: string) => void
  }
>

const Link = <T extends React.ElementType = 'a'>({
  as,
  className,
  children,
  href = '#',
  appearance = 'base',
  onClick,
  ...props
}: Props<T>) => {
  const Root = (as ?? 'a') as React.ElementType

  const handleClick: React.MouseEventHandler = event => {
    if (href === '#') {
      event.preventDefault()
    }

    if (onClick) {
      onClick(event, href)
    }
  }

  return (
    <Root
      type={Root === 'button' ? 'button' : undefined}
      {...props}
      className={cn(
        'Link',
        {
          [`appearance-${appearance}`]: !!appearance,
        },
        className
      )}
      href={href}
      onClick={handleClick}
    >
      {children}
    </Root>
  )
}

export default Link
